export const RIGHT_NAVIGATION_LAYOUT = "RightNavigationLayout";
export const MENU_ACCOUNT_ICON = "MenuAccountIcon";
export const SIGNUP_FIELDS_FORM = "SignupFieldsForm";
export const THANK_YOU_MODAL = "ThankYouForSignupModal";
export const SIGNUP_MODAL = "SignUpModalText";
export const LOGIN_MODAL = "LoginModal";
export const MY_ACCOUNT_PAGE = "MyAccountPage";

// User Profile address form fields — mirror the Checkout address form naming,
// prefixed with `profile` so selectors are scoped to the My Account page.
export const PROFILE_FULL_NAME_TEST_ID = "profile-full-name";
export const PROFILE_PHONETIC_FIRST_NAME_TEST_ID = "profile-phonetic-first-name";
export const PROFILE_PHONETIC_LAST_NAME_TEST_ID = "profile-phonetic-last-name";
export const PROFILE_ADDRESS_TEST_ID = "profile-address";
export const PROFILE_ADDRESS_LOOKUP_TEST_ID = "profile-address-lookup";
export const PROFILE_LANDMARK_TEST_ID = "profile-landmark";
export const PROFILE_ADDITIONAL_ADDRESS_TEST_ID = "profile-additional-address";
export const PROFILE_ADD_ADDRESS_LINE_TEST_ID = "profile-add-address-line";
export const PROFILE_ZIP_CODE_TEST_ID = "profile-zip-code";
export const PROFILE_CITY_TEST_ID = "profile-city";
export const PROFILE_REGION_TEST_ID = "profile-region";
export const PROFILE_DISTRICT_TEST_ID = "profile-district";
export const PROFILE_COUNTRY_TEST_ID = "profile-country";
export const PROFILE_DEFAULT_SHIPPING_ADDRESS_TEST_ID = "profile-default-shipping-address";

// User Profile address cards.
// Saved cards use this as a prefix: `profile-address-item-saved-<addressId>`.
// The current default shipping address is additionally flagged via the
// data-is-default attribute, so it can be located without knowing the id.
export const PROFILE_SAVED_ADDRESS_ITEM_TEST_ID = "profile-address-item-saved";
export const PROFILE_NEW_ADDRESS_ITEM_TEST_ID = "profile-address-item-new";
// Attribute on a saved card marking whether it is the default shipping address.
export const PROFILE_ADDRESS_DEFAULT_ATTRIBUTE = "data-is-default";

// Read-only lines of a saved address card (collapsed view), in render order.
// The name line is the full name (fullName, or firstName + lastName) and the
// phonetic line combines phoneticFirstName + phoneticLastName into one value.
export const PROFILE_ADDRESS_LINE_FULL_NAME_TEST_ID = "profile-address-line-full-name";
export const PROFILE_ADDRESS_LINE_PHONETIC_FULL_NAME_TEST_ID =
    "profile-address-line-phonetic-full-name";
export const PROFILE_ADDRESS_LINE_STREET_TEST_ID = "profile-address-line-street";
export const PROFILE_ADDRESS_LINE_ADDITIONAL_ADDRESS_TEST_ID =
    "profile-address-line-additional-address";
export const PROFILE_ADDRESS_LINE_DISTRICT_TEST_ID = "profile-address-line-district";
export const PROFILE_ADDRESS_LINE_CITY_POSTAL_CODE_TEST_ID =
    "profile-address-line-city-postal-code";
export const PROFILE_ADDRESS_LINE_COUNTRY_TEST_ID = "profile-address-line-country";

// User Profile address card actions.
export const PROFILE_ADDRESS_EDIT_BUTTON_TEST_ID = "profile-address-edit-button";
export const PROFILE_ADDRESS_REMOVE_BUTTON_TEST_ID = "profile-address-remove-button";
export const PROFILE_ADD_NEW_ADDRESS_BUTTON_TEST_ID = "profile-add-new-address-button";

// User Profile address form actions (edit/add form footer).
export const PROFILE_SAVE_ADDRESS_BUTTON_TEST_ID = "profile-save-address-button";
export const PROFILE_CANCEL_ADDRESS_BUTTON_TEST_ID = "profile-cancel-address-button";

export type TestAccount = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
};

const timestamp = Date.now();

export const TEST_ACCOUNT = {
    firstName: "John",
    lastName: "Doe",
    email: `test+${timestamp}@mail.com`,
    password: "Password123!",
};
